/* eslint-disable array-callback-return */
// 群接龙卡片
import React, { useCallback } from "react";
import "./index.less";
import { Card, Button } from "antd";
import { ChatMessage, Session } from "@/types/chat";
import IconFont from "@/components/icon";
import ChatState from "@/types/chat/State";
import solitaireMessageBody from "@jd/jdee.im.sdk/lib/es/protocol/message/solitaire";
import { connect } from "dva";
import { isBannedPostGroupSession } from "@/utils/chat/message";
import Context from "@/components/chat/context";

interface MessageOperateProps {
  message: solitaireMessageBody & ChatMessage;
  selectedSession: Session;
  updateSessionMessageMid: Function;
  openSolitaireDetails: (data: { isvisibles: boolean; solitaire: any }) => void;
}
type IProps = Readonly<MessageOperateProps & ChatState>;

function SolitaireCard(props: IProps) {
  const { message, selectedSession, openSolitaireDetails } = props;
  const { groupRosterIdentity, isSmall } = React.useContext(Context);

  // 打开组接龙
  const handleSolitaireClick = useCallback(async () => {
    openSolitaireDetails({
      isvisibles: true,
      solitaire: message.solitaireId
    });
  }, [message, openSolitaireDetails]);

  return (
    <div className="SolitaireCard">
      {message && (
        <Card
          title={
            <div className="titleIcon">
              <div className="titleIcon_icon">
                <IconFont
                  type="iconic_app_btn_groupsolitaire1"
                  className="titleIcon-icon-small-icon"
                />
                <span style={{ fontSize: "14px", color: "#333333", fontWeight: 700 }}>群接龙</span>
              </div>
              <div style={{ display: "flex", height: "24px", lineHeight: "23px" }}>
                <span style={{ width: isSmall ? "150px" : "160px" }}>{message.nickName}</span>
                <span>发布</span>
              </div>
            </div>
          }
          bordered={false}
          style={{ width: isSmall ? 273 : 300 }}
          // eslint-disable-next-line react/jsx-key
          actions={[
            <Button
              className="connect"
              onClick={(e) => {
                e.stopPropagation();
                if (
                  isBannedPostGroupSession(selectedSession) &&
                  groupRosterIdentity === "ordinary"
                ) {
                  return false;
                }
                handleSolitaireClick();
              }}
              key=""
            >
              立即接龙
            </Button>
          ]}
        >
          <div>
            <p
              onClick={(e) => {
                e.stopPropagation();
                if (
                  isBannedPostGroupSession(selectedSession) &&
                  groupRosterIdentity === "ordinary"
                ) {
                  return false;
                }
                handleSolitaireClick();
              }}
            >
              {message.title}
            </p>
          </div>
        </Card>
      )}
    </div>
  );
}

function mapStateToProps({ chat }: { chat: ChatState }) {
  const { sessionMessageMap, sessionMessages, messages, selectedSession, currentEmployee } = chat;
  return {
    sessionMessageMap,
    sessionMessages,
    selectedSession,
    currentEmployee,
    messages
  };
}
function mapDispatchToProps(dispatch: any) {
  return {
    openSolitaireDetails(data: { isvisibles: boolean; solitaire: any }) {
      dispatch({ type: "chat/openSolitaireDetails", payload: data });
    },
    updateSessionMessageMid(data: { sendResult: any; sessionId: String }) {
      dispatch({ type: "chat/updateSessionMessageMid", payload: data });
    }
  };
}
export default connect(mapStateToProps, mapDispatchToProps)(SolitaireCard);
